import React from 'react';
import $ from 'jquery';

class PackageSearchSorting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onSortClicked: props.onSort,
            onViewClicked: props.onSwitch,
            mobileSort: null
        };

        this.viewClicked = this.viewClicked.bind(this);
        this.sortClicked = this.sortClicked.bind(this);
        this.mobileSortClicked = this.mobileSortClicked.bind(this);
    }

    componentDidMount() {
        let p = this.props.search;
        if('sortby' in p && 'sort' in p) {
            this.state.onSortClicked(p.sortby, p.sort);
        }
    }

    viewClicked(view, ev) {
        this.state.onViewClicked(view);
    }

    sortClicked(type, direction, ev) {
        $('.sort_button').removeClass('active');
        $(ev.target).addClass('active');
        this.state.onSortClicked(type, direction);
    }

    mobileSortClicked(ev) {
        let select = $(ev.target).val();
        select = select.split(" ");
        if(select.length === 2) {
            this.state.onSortClicked(select[0], select[1]);
        }
    }

    render() {
        let listClass = "m-l-2";
        let gridClass = "search-not-active cursor-hover";
        if(this.props.view === 'grid') {
            listClass = "m-l-2 search-not-active cursor-hover";
            gridClass = "";
        }
        return (
            <div className="cf p-a-1-lg p-h-1">
                <div className="w-80-md w-60 fl">
                    <div className="sortby-desktop">
                        <p className="m-b-0 p-h-1 smaller-blue-font fcolor-og tl di p-r-1-lg">Sort by:</p>

                        <div className="btn__container di ">
                            <button className="btn btn__action sort_button" onClick={(ev) => this.sortClicked('price', 'dsc',ev)}><img src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/chevron-down.svg' alt="" width="15px"/>&nbsp;&nbsp; Price</button>
                        </div>
                        <div className="btn__container di p-l-1-lg p-l-0">
                            <button className="btn btn__action sort_button" onClick={(ev) => this.sortClicked('price', 'asc',ev)}><img src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/chevron-down.svg' alt="" width="15px"/>&nbsp;&nbsp; Price</button>
                        </div>
                        <div className="btn__container di p-l-1-lg p-l-0">
                            <button className="btn btn__action sort_button" onClick={(ev) => this.sortClicked('area', 'dsc',ev)}><img src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/chevron-down.svg' alt="" width="15px"/>&nbsp;&nbsp; Land Size</button>
                        </div>
                        <div className="btn__container di p-l-1-lg p-l-0">
                            <button className="btn btn__action sort_button" onClick={(ev) => this.sortClicked('area', 'asc',ev)}><img src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/chevron-down.svg' alt="" width="15px"/>&nbsp;&nbsp; Land Size</button>
                        </div>
                    </div>
                    <div className="sortby-mobile">
                        <select onChange={this.mobileSortClicked}>
                            <option>SORT BY</option>
                            <option value="price dsc">Price (High)</option>
                            <option value="price asc">Price (Low)</option>
                            <option value="area dsc">Land Size (High)</option>
                            <option value="area asc">Land Size (Low)</option>
                        </select>
                    </div>

                </div>

                <div className="w-20-md w-40 fr db-in tr land-search-options">
                    <a onClick={(ev) => this.viewClicked('grid',ev)} className={gridClass}>
                        <img className="grid-icon" src="https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/grid-icon.svg" alt=""/>
                    </a>

                    <a onClick={(ev) => this.viewClicked('list',ev)} className={listClass}>
                        <img className="list-icon" src="https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/list-icon.svg" alt=""/>
                    </a>
                </div>
            </div>
        )
    }
}

export default PackageSearchSorting;


/** WEBPACK FOOTER **
 ** ./src/modules/common/PackageSearchSorting.js
 **/